import { LatLng } from '@shared/models/latlng.model'
import { AbstractMapAdapter } from './abstract-map-adapter'
import { FitBoundsOptions } from 'leaflet'

export class AbstractGoogleMapAdapter extends AbstractMapAdapter {
  map: google.maps.Map

  initMap(map: HTMLElement) {
    this.map = new google.maps.Map(map)
  }

  fitBounds(coordinates: LatLng | LatLng[], options?: FitBoundsOptions) {
    coordinates = !Array.isArray(coordinates) ? [coordinates] : coordinates
    const bounds: google.maps.LatLngBounds = new google.maps.LatLngBounds()
    const extendLatLngToBounds = ({ lat, lng }) => bounds.extend(new google.maps.LatLng(lat, lng))

    coordinates.forEach(extendLatLngToBounds)

    !bounds.isEmpty() && this.map.fitBounds(bounds)
  }
}
